import { SelectOption } from "o4a-react";
import * as React from "react";
import { TagsInput } from "../../components/Tags/TagsInput";

export const GROUP_TAGS = "tags";

export const enum Fields { tags= "freeformTags" }

export interface TagsTabContentProps {

  resourceOptions: SelectOption[];
}

export const TagsTabContent = ({ resourceOptions }: TagsTabContentProps): JSX.Element => (

  <TagsInput fieldName={Fields.tags} resourceOptions={resourceOptions} />);
